.fulfillments-page-wrapper {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  position: relative;
  overflow-x: hidden;
  .toggle-icon {
    top: 14px;
  }

  > div:last-child {
    flex: 1;
    overflow-x: auto;
    min-width: 0;
  }
}
